// routerUtils.js
export function goToHome(router) {
    // console.log('=== router >>>', router);
    router.push('/');
}
